import { Component, computed, input } from '@angular/core';

import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { PeppolStatus } from '../../services/dto/peppol-status';

export const peppolStatusLabel = (peppolStatus: PeppolStatus) =>
  `project.peppolStatus.${PeppolStatus[peppolStatus]?.toLowerCase() ?? 'unknown'}`;

@Component({
  imports: [BadgeComponent, TranslatePipe],
  selector: 'cam-billings-peppol-status',
  styleUrl: './peppol-status.component.scss',
  templateUrl: './peppol-status.component.html',
})
export class CamPeppolStatusComponent extends CamBaseComponent {
  status = input.required<PeppolStatus>();

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  readonly type = computed<ColorType>(() => {
    switch (this.status()) {
      case PeppolStatus.Sent:
        return 'default';
      case PeppolStatus.Delivered:
      case PeppolStatus.Acknowledged:
      case PeppolStatus.Accepted:
      case PeppolStatus.Received:
        return 'success';
      case PeppolStatus.ConditionallyAccepted:
      case PeppolStatus.UnderQuery:
        return 'warning';
      case PeppolStatus.Rejected:
      case PeppolStatus.NotDelivered:
      case PeppolStatus.Error:
      case PeppolStatus.Skipped:
        return 'alert';
      default:
        return 'new';
    }
  });

  readonly label = computed(() => peppolStatusLabel(this.status()));
}
